import { LoanProductCategory } from "@appTypes/LoansApi.interface"

export const categories = {
    [LoanProductCategory.Personal]: {
        path: 'all',
        name: 'All Loans',
    },
    [LoanProductCategory.PoorCredit]: {
        path: 'bad-credit',
        name: 'Bad Credit',
    },
    [LoanProductCategory.Guarantor]: {
        path: 'guarantor',
        name: 'Guarantor',
    },
    [LoanProductCategory.CarFinance]: {
        path: 'car-finance',
        name: 'Car Finance',
    },
    [LoanProductCategory.Secured]: {
        path: 'homeowner',
        name: 'Homeowner',
    },
    [LoanProductCategory.AlternativeProducts]: {
        path: 'alternative-products',
        name: 'Alternative Products',
    },
} as const

export const categoryPaths = Object.keys(categories).map(
    category => categories[category as keyof typeof categories].path
)

export type CategoryPath = (typeof categories)[keyof typeof categories]['path']
